import styled from "styled-components";
import { ZIndexes } from "@glossy";

export default styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${ZIndexes.Panel};
`;
